import React from 'react';
import LegalLayout from '@/components/LegalLayout';

export default function SafetyPolicy() {
  return (
    <LegalLayout title="Safety Policy" testId="safety-policy-page">
      <p>
        Your safety — and our Partners' safety — is at the heart of
        BeautyMateUK. This policy explains how we operate, what we expect from
        Customers and Partners, and how to flag concerns.
      </p>

      <h2>1. Booking hours</h2>
      <p>
        BeautyMateUK only accepts bookings between <strong>06:00 and 23:00 UK
        local time</strong>. This window allows us to monitor activity, route
        support effectively, and protect both Customers and Partners working at
        home addresses. Bookings outside these hours are not permitted and are
        not covered by Platform support.
      </p>

      <h2>2. Partner verification</h2>
      <ul>
        <li>Photo ID and right-to-work checks before going live.</li>
        <li>Required public liability insurance.</li>
        <li>Professional indemnity / malpractice cover where relevant.</li>
        <li>DBS check on file.</li>
        <li>Council licence or exemption evidence where relevant.</li>
        <li>Hygiene and equipment declaration acknowledged.</li>
      </ul>

      <h2>3. On-platform booking only</h2>
      <p>
        For your safety and protection, BeautyMateUK support, booking records,
        payment protection, and dispute handling only apply to bookings made and
        paid through the Platform. Please do not arrange direct bookings with
        Partners off-platform.
      </p>

      <h2>4. In-home appointment guidance</h2>
      <ul>
        <li>Confirm the Partner's identity before letting them in.</li>
        <li>Choose a well-lit, ventilated space for the service.</li>
        <li>Tell us immediately if you feel unsafe.</li>
        <li>Partners must respect property and household members at all times.</li>
      </ul>

      <h2>5. Reporting a concern</h2>
      <p>
        Email <a href="mailto:safety@beautymateuk.com">safety@beautymateuk.com</a>
        or use the “Report an issue” link in your booking history. We take all
        reports seriously and may suspend Partners while we investigate.
      </p>

      <h2>6. Zero tolerance</h2>
      <p>
        We have a zero-tolerance approach to harassment, discrimination, and
        unsafe practice from any party. Confirmed breaches result in immediate
        removal from the Platform.
      </p>
    </LegalLayout>
  );
}
